import { Component, Children } from 'react';
import { func, node, number, object } from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { graphql } from 'react-apollo';
import { FETCH_ALL_EXCEPT_ACTIVITIES } from 'api/activity';
import { getFieldsListFromData } from 'api/util';
import growTypes from './proptypes';
import isEqual from 'lodash.isequal';
import { store } from 'store';
import { UPDATE_MAP_FIELDS, UPDATE_MAP_STORAGES } from 'common/constants';

const defaultData = {
  fields: [],
  crops: [],
  storages: [],
  contracts: [],
};

const formatData = data => {
  if (!data) {
    return defaultData;
  }

  const fields = data.getAllFields ? getFieldsListFromData(data) : [];
  return {
    fields,
    crops: data.getAllCropsForField,
    storages: data.getAllStorages,
    contracts: data.getAllContracts,
  };
};

class GrowProvider extends Component {
  static childContextTypes = growTypes;
  static propTypes = {
    children: node,
    season: number,
    data: object,
    updateMapFields: func,
    updateMapStorages: func,
  };

  state = { data: {} };

  updateMapData = data => {
    const { updateMapFields, updateMapStorages } = this.props;
    updateMapFields(data.fields);
    updateMapStorages(data.storages);
  };

  updateData = data => {
    if (!data) {
      return null;
    }
    const { season } = this.props;
    const oldData = this.state.data[season] || {};
    let newData = { ...this.state.data };

    // if the data is the same as old data, keep the old data
    if (isEqual(data, oldData)) {
      newData[season] = oldData;
      // otherwise update the data in state
    } else {
      newData[season] = data;
      this.setState({ season, data: newData });
    }
    // update the map data
    this.updateMapData(newData[season]);
  };

  componentDidMount() {
    this.updateData(this.props.data);
  }

  componentDidUpdate(prevProps) {
    const { season, data } = this.props;
    // do only when data or season updated
    if (isEqual(prevProps.data, data) && prevProps.season === season) {
      return;
    }
    this.updateData(data);
  }

  getChildContext() {
    const { season, data: stateData } = this.state;
    const data =
      stateData && stateData[season] ? stateData[season] : defaultData;
    // might not use this for now
    const actions = {
      // updateAll: this.updateAll // TODO: not tested
    };
    return { data, actions };
  }

  render() {
    return Children.only(this.props.children);
  }
}
const mapState = ({ settings }) => ({ season: settings.season });
const mapDispatch = {
  updateMapFields: payload => ({ type: UPDATE_MAP_FIELDS, payload }),
  updateMapStorages: payload => ({ type: UPDATE_MAP_STORAGES, payload }),
};

const enhance = compose(
  connect(
    mapState,
    mapDispatch
  ),
  // moved from BaseApp
  graphql(FETCH_ALL_EXCEPT_ACTIVITIES, {
    options: () => ({
      variables: { active: true, season: store.getState().settings.season },
      fetchPolicy: 'cache-and-network',
    }),
    props: ({ loading, error, data }) => {
      if (loading || error || !data) {
        return null;
      }
      return {
        data: formatData(data),
      };
    },
  })
);

export default enhance(GrowProvider);



// WEBPACK FOOTER //
// ./src/hoc/grow/GrowProvider.js